import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=8f0abbaa&scoped=true&lang=pug&"
import script from "./Step1.vue?vue&type=script&lang=js&"
export * from "./Step1.vue?vue&type=script&lang=js&"
import style0 from "./Step1.vue?vue&type=style&index=0&id=8f0abbaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0abbaa",
  null
  
)

export default component.exports